import { render, staticRenderFns } from "./App.vue?vue&type=template&id=70365ca8&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=70365ca8&prod&lang=scss&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=70365ca8&prod&lang=scss"
import style2 from "./App.vue?vue&type=style&index=2&id=70365ca8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70365ca8",
  null
  
)

export default component.exports